import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _Number$isInteger from "@babel/runtime-corejs3/core-js-stable/number/is-integer";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import * as React from 'react';
import classnames from 'classnames';
import ConfigContext from '../config-provider/ConfigContext';
import { getCompProps } from '../_utils';
import devWarning from '../_utils/devwarning';
import { tuple } from '../_utils/type';
export var SizeTypes = tuple('large', 'middle', 'small');

var Rate = function Rate(props) {
  var _context2, _classnames2;

  var _React$useContext = React.useContext(ConfigContext),
      getPrefixCls = _React$useContext.getPrefixCls,
      pkgPrefixCls = _React$useContext.prefixCls,
      userDefaultProps = _React$useContext.compDefaultProps;

  var _getCompProps = getCompProps('Rate', userDefaultProps, props),
      customPrefixcls = _getCompProps.prefixCls,
      allowHalf = _getCompProps.allowHalf,
      icon = _getCompProps.icon,
      activeIcon = _getCompProps.activeIcon,
      count = _getCompProps.count,
      defaultValue = _getCompProps.defaultValue,
      value = _getCompProps.value,
      onlyActiveCurrent = _getCompProps.onlyActiveCurrent,
      disabled = _getCompProps.disabled,
      color = _getCompProps.color,
      size = _getCompProps.size,
      className = _getCompProps.className,
      style = _getCompProps.style,
      onBlur = _getCompProps.onBlur,
      onChange = _getCompProps.onChange,
      onHoverChange = _getCompProps.onHoverChange,
      onFocus = _getCompProps.onFocus;

  devWarning(SizeTypes.indexOf(size) === -1, 'Rate', "cannot found SizeType '".concat(size, "'")); // className前缀

  var prefixCls = getPrefixCls(pkgPrefixCls, 'rate', customPrefixcls);

  var _React$useState = React.useState(defaultValue),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      selectedValue = _React$useState2[0],
      setSelectedValue = _React$useState2[1]; // 当前选中的值，包含一位小数


  var _React$useState3 = React.useState(0),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      activeNumber = _React$useState4[0],
      setActiveNumber = _React$useState4[1]; // 鼠标悬停icon位置对应的值


  React.useEffect(function () {
    if (value !== undefined && value !== selectedValue) {
      setSelectedValue(value);
    }
  }, [value, selectedValue]); // const shouldSetValue = (value: number) => {
  //   return value && value !== 0 && value !== selectedValue
  // }

  var handleClick = React.useCallback(function (value) {
    setSelectedValue(value);
    onChange && onChange(value);
  }, [onChange]);
  var handleMouseEnter = React.useCallback(function (value) {
    setActiveNumber(value);
    onHoverChange && onHoverChange(value);
  }, [onHoverChange]);

  var handleMouseLeave = function handleMouseLeave() {
    setActiveNumber(0);
  };

  var handleFocus = React.useCallback(function () {
    onFocus && onFocus();
  }, [onFocus]);
  var handleBlur = React.useCallback(function () {
    onBlur && onBlur();
  }, [onBlur]);
  /**
   *获取图标
   * @param icon
   * @param index
   */

  var getIcon = function getIcon(icon, activeIcon, index, isActive) {
    if (activeIcon && isActive) {
      icon = activeIcon;
    }

    if (typeof icon === 'function') {
      return /*#__PURE__*/React.createElement("span", {
        className: "".concat(prefixCls, "-icon-wrapper")
      }, icon(index));
    }

    return /*#__PURE__*/React.createElement("span", {
      className: "".concat(prefixCls, "-icon-second-content")
    }, icon);
  };
  /**
   * 获取第一个图标状态
   * @param value
   * @param index
   * @param onlyActiveCurrent
   * @param isSecondIconActive
   */


  var getFirstIconStatus = function getFirstIconStatus(value, index, onlyActiveCurrent, secondIconStatus) {
    var half = 0.5;

    var isInteger = _Number$isInteger(value);

    value = transferValue(value, index);
    var isActiveAllLeft = value >= index || value === index - half;
    var isActiveCurrent = value === index;
    var isActiveFirst = value === index - half;
    var mark;

    if (secondIconStatus) {
      // 第二个图标被激活则第一个也必须激活
      mark = true;
    } else if (!onlyActiveCurrent) {
      // 激活点击位置所有左侧图标
      mark = isActiveAllLeft;
    } else if (isInteger) {
      // 点击全图标只激活当前点击图标
      mark = isActiveCurrent;
    } else {
      mark = isActiveFirst; // 点击半个图标只激活当前点击图标
    }

    return mark;
  };

  var transferValue = function transferValue(value, index) {
    var half = 0.5;

    if (index - value === half) {
      return value;
    } else {
      return Math.round(value);
    }
  };
  /**
   * 获取第二个图标状态
   * @param value
   * @param index
   * @param onlyActiveCurrent
   */


  var getSecondIconStatus = function getSecondIconStatus(value, index, onlyActiveCurrent) {
    if (!onlyActiveCurrent) {
      // 激活所有左侧图标
      return value >= index;
    } else {
      return value === index; // 只激活当前点击图标
    }
  };
  /**
   * 返回图标的样式
   * @param isActive
   */


  var getIconStyle = function getIconStyle(isActive) {
    if (isActive) return {
      color: color
    };
  };
  /**
   *
   * @param selectActive 当前图标是否被选中
   * @param mouseActive 当前图标是否触发鼠标hover效果
   */


  var isSelected = function isSelected(selectActive, mouseActive) {
    return activeNumber !== 0 ? mouseActive : selectActive;
  };

  var getIconClassName = function getIconClassName(name, isActive) {
    var _context, _classnames;

    return classnames((_classnames = {}, _defineProperty(_classnames, _concatInstanceProperty(_context = "".concat(prefixCls, "-icon-")).call(_context, name), true), _defineProperty(_classnames, "".concat(prefixCls, "-icon-selected"), isActive), _classnames));
  };
  /**
   * 获取图标视图
   */


  var getRateIconView = function getRateIconView() {
    var half = 0.5;
    var rateIconsView = [];

    var _loop = function _loop(i) {
      var isMouseOnSecondIcon = getSecondIconStatus(activeNumber, i, onlyActiveCurrent);
      var isMouseOnFirstIcon = getFirstIconStatus(activeNumber, i, onlyActiveCurrent, isMouseOnSecondIcon);
      var isSecondSelected = getSecondIconStatus(selectedValue, i, onlyActiveCurrent);
      var isFirstSelected = getFirstIconStatus(selectedValue, i, onlyActiveCurrent, isSecondSelected);
      var isFirstActive = isSelected(isFirstSelected, isMouseOnFirstIcon);
      var isSecondActive = isSelected(isSecondSelected, isMouseOnSecondIcon);
      var IconStyle = getIconStyle(isFirstActive);
      var firstIconStyle = getIconStyle(isFirstActive);
      var firstIconClassName = getIconClassName('first', isFirstActive);
      var secondIconClassName = getIconClassName('second', isSecondActive);
      rateIconsView.push( /*#__PURE__*/React.createElement("span", {
        className: "".concat(prefixCls, "-item"),
        key: i
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-icon-view")
      }, allowHalf && /*#__PURE__*/React.createElement("span", {
        style: firstIconStyle,
        className: firstIconClassName,
        onClick: function onClick() {
          return handleClick(i - half);
        },
        onMouseEnter: function onMouseEnter() {
          return handleMouseEnter(i - half);
        },
        onMouseLeave: function onMouseLeave() {
          return handleMouseLeave();
        }
      }, getIcon(icon, activeIcon, i, isFirstActive)), /*#__PURE__*/React.createElement("span", {
        style: IconStyle,
        className: secondIconClassName,
        onClick: function onClick() {
          return handleClick(i);
        },
        onMouseEnter: function onMouseEnter() {
          return handleMouseEnter(i);
        },
        onMouseLeave: function onMouseLeave() {
          return handleMouseLeave();
        }
      }, getIcon(icon, activeIcon, i, isSecondActive)))));
    };

    for (var i = 1; i <= count; i++) {
      _loop(i);
    }

    return rateIconsView;
  };
  /**
   * 获取图标下方情感描述文字
   * @param index 图标对应索引
   */
  //   const getEmotionalTextView = (index:number):React.ReactNode => {
  //     return (
  //         <span className={`${prefixCls}-item-text`}>
  //           {emotionalText[index] ? emotionalText[index] : null}
  //         </span>
  //     )
  //   }


  var getRateClassName = classnames(prefixCls, className, (_classnames2 = {}, _defineProperty(_classnames2, _concatInstanceProperty(_context2 = "".concat(prefixCls, "-size-")).call(_context2, size), size), _defineProperty(_classnames2, "".concat(prefixCls, "-disabled"), disabled), _classnames2));
  var rate = /*#__PURE__*/React.createElement("span", {
    className: getRateClassName,
    style: style,
    onMouseLeave: function onMouseLeave() {
      return handleBlur();
    },
    onMouseEnter: function onMouseEnter() {
      return handleFocus();
    }
  }, getRateIconView());
  return rate;
};

Rate.displayName = 'Rate';
export default Rate;